export function fmtMs(ms: number): string {
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.round(ms)}ms`;
}
export function fmtBytesMB(mb: number): string {
  if (mb >= 1024) return `${(mb / 1024).toFixed(1)} GB`;
  return `${Math.round(mb)} MB`;
}
export function fmtCount(n: number): string {
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return String(n);
}
/** Compact token count: 1.2M / 3.4k / 567. */
export function fmtTokens(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return String(n);
}
/** Estimated CNY cost: ¥0.123 under 1, ¥12.34 above, ¥1.2k for large sums. */
export function fmtCny(n: number): string {
  if (n >= 1000) return `¥${(n / 1000).toFixed(1)}k`;
  if (n >= 1) return `¥${n.toFixed(2)}`;
  return `¥${n.toFixed(3)}`;
}
/** A rate already expressed 0-100 as a percent label. */
export function fmtPct(n: number): string {
  return `${Math.round(n)}%`;
}
/**
 * The chart's adaptive aggregation bucket as a plain-language unit, so a per-bucket
 * figure reads as "次/小时" instead of the internal "次/桶". Mirrors the bucket
 * ladder in server/db/window.ts (1m…7d).
 */
export function fmtBucketUnit(ms: number): string {
  const m = Math.round(ms / 60000);
  if (m < 60) return m <= 1 ? "分钟" : `${m} 分钟`;
  const h = Math.round(ms / 3_600_000);
  if (h < 24) return h <= 1 ? "小时" : `${h} 小时`;
  const d = Math.round(ms / 86_400_000);
  return d <= 1 ? "天" : `${d} 天`;
}
export function fmtRelative(ts: number, now: number = Date.now()): string {
  const s = Math.max(0, Math.round((now - ts) / 1000));
  if (s < 60) return s < 5 ? "刚刚" : `${s} 秒前`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} 分钟前`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} 小时前`;
  return `${Math.round(h / 24)} 天前`;
}

/** Absolute local time as "YYYY-MM-DD HH:MM". */
export function fmtAbsTime(ts: number): string {
  const d = new Date(ts);
  const p = (n: number): string => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

/** Render an annotation's `payload` (object or scalar) as a display string. */
export function formatAnnotationPayload(payload: unknown): string {
  return typeof payload === "object" && payload !== null ? JSON.stringify(payload) : String(payload);
}
